let layout = {
    layout: 'v-spa-layout-layout h-screen',
    container: 'v-spa-layout-container flex h-full relative z-40 pt-top-bar',
    header: 'v-spa-layout-header bg-white h-top-bar flex fixed top-0 left-0 right-0 z-50 shadow-top-bar',
    content: 'v-spa-layout-content flex-1 h-full relative max-h-screen overflow-y-auto',
    sidebar: 'v-spa-layout-sidebar flex-shrink-0 bg-sidebar hidden md:flex w-sidebar-tablet lg:w-sidebar h-full relative z-10 max-h-screen shadow-top-bar flex-col',
    responsive_sidebar: 'v-spa-layout-responsive_sidebar p-8 flex-grow',
    sidebar_link: 'v-spa-layout-sidebar_link p-2 flex items-center justify-center lg:justify-start font-normal group w-full text-sidebar-link rounded mb-1 hover:bg-sidebar-dark hover:text-sidebar-link-hover no-underline transition-all duration-300 relative flex align-center text-sm',
    sidebar_link_active: 'v-spa-layout-sidebar_link_active bg-sidebar-dark text-sidebar-link-active',
    sidebar_link_icon: 'v-spa-layout-sidebar_link_icon lg:mr-2 text-lg text-sidebar-link-icon hover:text-sidebar-link-icon-hover w-[22px] text-center',
    sidebar_link_icon_active: 'v-spa-layout-sidebar_link_icon_active text-sidebar-link-icon-active',
    sidebar_spacer_container: 'v-spa-layout-sidebar_spacer_container py-2',
    sidebar_spacer: 'v-spa-layout-sidebar_spacer border-t border-slate-200',
    title_container: 'v-spa-layout-title_container flex w-full mb-12',
    title: 'v-spa-layout-title text-lg md:text-xl text-slate-800 font-normal',
    page_tabs: {
        container: 'flex space-x-8',
        tab: 'pb-2 text-gray-600 whitespace-nowrap',
        tab_active: 'v-spa-layout-page-tab-active'
    }
};


export default layout;